import { createTheme } from '@mui/material/styles';
import { MuiAlert, MuiBreadcrumbs, MuiButton, MuiDialog, MuiDialogTitle, MuiFormControlLabel, MuiMenu, MuiSwitch, MuiTab, MuiTooltip } from './core';

export const vdsMuiTheme = createTheme({
    components: {
        MuiMenu,
        MuiFormControlLabel,
        MuiButton,
        MuiBreadcrumbs,
        MuiTooltip,
        MuiDialog,
        MuiDialogTitle,
        MuiAlert,
        MuiSwitch,
        MuiTab
    }
});
